import { createSlice } from "@reduxjs/toolkit";

import { getPdaCalculatorReportData, addPdaCalculatorReportData } from "../thunks/pdaCalculatorThunk";

interface pdaCalculatorListState {
  addPda: any[];
  pdaCalculatorSuccess:any;
  loading: boolean;
  error: string | null;
};

const initialState: pdaCalculatorListState = {
    addPda: [],
    pdaCalculatorSuccess:null,
    loading: false,
    error: null,
};

export const pdaCalculatorSlices = createSlice({
  name: "pdaCalculator",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPdaCalculatorReportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPdaCalculatorReportData.fulfilled, (state, action) => {
        state.pdaCalculatorSuccess = action.payload;
        state.loading = false;
      })
      .addCase(getPdaCalculatorReportData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(addPdaCalculatorReportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(addPdaCalculatorReportData.fulfilled, (state, action) => {
        state.addPda = action.payload;
        state.loading = false;
      })
      .addCase(addPdaCalculatorReportData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export default pdaCalculatorSlices.reducer;